import React from 'react'

export default function VerticalSpace({ height }) {
  return (
    <div style={{ height: height || '5px' }}></div>
  )
}